"use strict";
// Copyright © Veeam Software Group GmbH.
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewRequestManager = void 0;
const NewRequest_1 = require("./NewRequest");
class NewRequestManager {
    constructor(config = {}) {
        this.config = config;
    }
    createRequest(requestConfig) {
        const _a = this.config, { headers, headersProvider } = _a, restConfig = __rest(_a, ["headers", "headersProvider"]);
        return new NewRequest_1.NewRequest(Object.assign(Object.assign(Object.assign({}, restConfig), requestConfig), { headers: Object.assign(Object.assign({}, headers), requestConfig.headers), headersProvider: headersProvider !== null && headersProvider !== void 0 ? headersProvider : requestConfig.headersProvider }));
    }
}
exports.NewRequestManager = NewRequestManager;
//# sourceMappingURL=NewRequestManager.js.map